module.exports = __webpack_public_path__ + "img/CF_2W.cdc223c1.jpg";